const navBarDashboard = [
  {
    text: 'programs',
    key: 'Programs',
    routeName: 'Programs',
    show: 'true',
  },
  // {
  //   text: 'Dashboard',
  //   key: 'Dashboard',
  //   routeName: 'CCDashboard',
  //   show: 'true',
  // },
  {
    text: 'Messages',
    key: 'Messages',
    routeName: 'CCMessages',
    show: 'true',
  },
  {
    text: 'forms',
    key: 'Forms',
    routeName: 'CCForms',
    show: 'true',
  },
  {
    text: 'assets',
    key: 'Assets',
    routeName: 'CCAssets',
    show: 'true',
  },
  // {
  //   text: 'Security Center',
  //   key: 'SecurityCenter',
  //   routeName: 'CCSecuritycenter',
  //   show: 'true',
  // },
  // {
  //   text: 'Communication Center',
  //   key: 'assets',
  //   routeName: 'CCCommunicationcenter',
  //   show: 'true',
  // },
];

export default () => navBarDashboard;
